if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          form: "form",
          inputId: "[name=id]",
          submitButton: '[name="add"]',
          errorWrapper: ".f-product-form__error-message-wrapper",
          customFields: ["[data-product-custom-field]"],
        };

        this.domNodes = queryDomNodes(this.selectors, this);

        this.form = this.domNodes.form;
        this.submitButton = this.domNodes.submitButton;
        this.domNodes.inputId.disabled = false;
        this.Notification = window.FoxTheme.Notification;
        this.notificationType = this.dataset.notificationType;
        this.customFields = document.querySelectorAll(
          this.selectors.customFields
        );
        this.cartDrawer = document.querySelector("cart-drawer");
        this.mainCart = document.querySelector("cart-items");
        this.type = this.dataset.type;

        this.variantIdInput = this.domNodes.inputId;

        this.errorWrapper =
          this.type === "product-card"
            ? this.closest(".product-card")
            : this.domNodes.errorWrapper;

        this.form &&
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      }

      validateForm(form) {
        const missingFields = [];
        if (!form) return missingFields;
        const fieldSelectors =
          '[data-product-custom-field] [name][required]:not([hidden]):not([type="hidden"])';
        const requiredFields = form.querySelectorAll(fieldSelectors);
        requiredFields.forEach((field) => {
          field.classList.remove("form-control--warning");
          if (field.type === "radio") {
            const buttons = form.querySelectorAll(
              `input[name="${field.name}"]`
            );
            const selected = Array.from(buttons).some((btn) => btn.checked);
            if (!selected) {
              missingFields.push(field);
              field.classList.add("form-control--warning");
            }
          } else if (!field.value) {
            missingFields.push(field);
            field.classList.add("form-control--warning");
          }
        });
        return missingFields;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const missing = this.validateForm(
          this.form.closest(".f-product-single__blocks")
        );

        if (missing && missing.length > 0) {
          return this.Notification.show({
            target: this.domNodes.errorWrapper,
            method: "appendChild",
            type: "warning",
            message: window.FoxThemeStrings.requiredField,
            last: 20000,
          });
        }

        if (this.submitButton.classList.contains("btn--loading")) return;

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("btn--loading");

        const config = {
          method: "POST",
          headers: {
            Accept: "application/javascript",
            "X-Requested-With": "XMLHttpRequest",
          },
        };

        const formData = new FormData(this.form);

        let sectionToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:grouped-sections", {
            bubbles: true,
            detail: { sections: sectionToBundle },
          })
        );

        if (this.cartDrawer) {
          sectionToBundle = [
            ...sectionToBundle,
            ...this.cartDrawer
              .getSectionsToRender()
              .map((section) => section.id),
          ];
        }

        if (this.mainCart) {
          sectionToBundle = [
            ...sectionToBundle,
            ...this.mainCart
              .getSectionsToRender()
              .map((section) => section.section),
          ];
        }

        formData.append("sections", sectionToBundle);

        if (this.mainCart || this.cartDrawer) {
          formData.append("sections_url", window.location.pathname);
        }

        config.body = formData;
        const { FoxThemeSettings, FoxThemeStrings } = window;
        fetch(`${FoxThemeSettings.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            console.log('🛒 [ProductForm] Cart add response received:', response);
            console.log('🛒 [ProductForm] Response status:', response.status);
            console.log('🛒 [ProductForm] Response item_count:', response.item_count);
            console.log('🛒 [ProductForm] Response has sections:', !!(response.sections && Object.keys(response.sections).length > 0));
            
            if (response.status) {
              console.log('🛒 [ProductForm] Status response detected (warning/error)');
              console.log('🛒 [ProductForm] Status message:', response.description || response.message);
              
              window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.description,
                message: response.message,
              });

              // Dispatch event for third-party
              document.dispatchEvent(
                new CustomEvent("product-ajax:error", {
                  detail: {
                    errorMessage: response.description,
                  },
                })
              );

              this.error = true;
              
              // Show warning notification
              const warningMessage = response.description || response.message;
              
              // Show notification on product page
              this.Notification.show({
                target:
                  this.notificationType === "toast"
                    ? document.body
                    : this.errorWrapper,
                method: "appendChild",
                type: "warning",
                message: warningMessage,
                last: 20000,
                sticky: this.notificationType === "toast",
              });
              
              // Also show the same message in cart drawer
              const cartDrawerErrorContainer = document.querySelector('.f-cart-drawer__error-message-wrapper-container');
              if (cartDrawerErrorContainer) {
                // Create notification HTML matching the structure
                const notificationHTML = `
                  <div class="f-notification warning show">
                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    <div class="ml-3">${warningMessage}</div>
                  </div>
                `;
                
                // Clear any existing notification and add new one
                cartDrawerErrorContainer.innerHTML = notificationHTML;
                
                // Auto-hide after 20 seconds
                setTimeout(() => {
                  const notification = cartDrawerErrorContainer.querySelector('.f-notification');
                  if (notification) {
                    notification.classList.add('hide');
                    setTimeout(() => {
                      cartDrawerErrorContainer.innerHTML = '';
                    }, 600); // Wait for transition
                  }
                }, 20000);
              }
              
              // When there's a status/warning (like 422), Shopify doesn't include cart data in response
              // We need to fetch the cart state to check if items were actually added (partial success)
              console.log('🛒 [ProductForm] Status response detected - fetching cart state to check for partial success...');
              
              // Fetch cart state with sections to check if items were added and update drawer
              let sectionToFetch = [];
              if (this.cartDrawer) {
                const drawerSections = this.cartDrawer.getSectionsToRender(true);
                console.log('🛒 [ProductForm] Drawer sections to render:', drawerSections);
                sectionToFetch = [
                  ...sectionToFetch,
                  ...drawerSections.map((section) => section.id),
                ];
              }
              if (this.mainCart) {
                const mainCartSections = this.mainCart.getSectionsToRender();
                console.log('🛒 [ProductForm] Main cart sections to render:', mainCartSections);
                sectionToFetch = [
                  ...sectionToFetch,
                  ...mainCartSections.map((section) => section.section),
                ];
              }
              
              console.log('🛒 [ProductForm] Sections to fetch:', sectionToFetch);
              
              if (sectionToFetch.length > 0) {
                console.log('🛒 [ProductForm] Fetching cart state with sections...');
                // Use cart/update.js with empty updates to get sections
                const updateBody = JSON.stringify({
                  updates: {},
                  sections: sectionToFetch,
                  sections_url: window.location.pathname,
                });
                
                console.log('🛒 [ProductForm] Fetch URL:', FoxThemeSettings.routes.cart_update_url);
                console.log('🛒 [ProductForm] Fetch body:', updateBody);
                
                fetch(`${FoxThemeSettings.routes.cart_update_url}`, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                  },
                  body: updateBody,
                })
                  .then((res) => {
                    console.log('🛒 [ProductForm] Cart update fetch response status:', res.status);
                    return res.json();
                  })
                  .then((cartState) => {
                    console.log('🛒 [ProductForm] ✅ Cart state with sections fetched:', cartState);
                    console.log('🛒 [ProductForm] Cart state item_count:', cartState.item_count);
                    console.log('🛒 [ProductForm] Cart state has sections:', !!(cartState.sections && Object.keys(cartState.sections).length > 0));
                    
                    // Check if items were actually added (cart has items)
                    const hasItems = cartState.item_count > 0 || (cartState.items && cartState.items.length > 0);
                    console.log('🛒 [ProductForm] Cart has items:', hasItems);
                    console.log('🛒 [ProductForm] Previous cart count (if available):', window.FoxTheme?.Cart?.previousItemCount);
                    
                    if (hasItems) {
                      console.log('🛒 [ProductForm] ✅ Partial success confirmed! Items were added to cart.');
                      
                      // Update cart count immediately
                      if (cartState.item_count !== undefined) {
                        console.log('🛒 [ProductForm] Updating cart count to:', cartState.item_count);
                        if (this.cartDrawer) {
                          console.log('🛒 [ProductForm] Calling cartDrawer.updateCartCountElements');
                          this.cartDrawer.updateCartCountElements(cartState.item_count);
                        }
                        if (window.FoxThemeCartHelpers) {
                          console.log('🛒 [ProductForm] Calling FoxThemeCartHelpers.updateCartCount');
                          window.FoxThemeCartHelpers.updateCartCount(cartState.item_count);
                        }
                      }
                      
                      // Emit cartUpdate event with full cart state including sections
                      console.log('🛒 [ProductForm] Emitting cartUpdate event with cartState');
                      window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, cartState);
                    } else {
                      console.log('🛒 [ProductForm] ⚠️ No items in cart, skipping cart update');
                    }
                  })
                  .catch((e) => {
                    console.error('🛒 [ProductForm] ❌ Error fetching cart state:', e);
                    console.log('🛒 [ProductForm] Attempting fallback: fetch cart.js directly');
                    
                    // Fallback: try fetching cart.js directly
                    fetch(`${FoxThemeSettings.routes.cart_url}.js`)
                      .then((res) => res.json())
                      .then((cartData) => {
                        console.log('🛒 [ProductForm] Fallback cart data fetched:', cartData);
                        if (cartData.item_count > 0) {
                          // Update cart count
                          if (this.cartDrawer) {
                            this.cartDrawer.updateCartCountElements(cartData.item_count);
                          }
                          if (window.FoxThemeCartHelpers) {
                            window.FoxThemeCartHelpers.updateCartCount(cartData.item_count);
                          }
                          // Trigger cart refresh to update drawer content
                          document.dispatchEvent(
                            new CustomEvent("cart:refresh", {
                              detail: { open: FoxThemeSettings.cart.openDrawerWhenAdded !== false },
                            })
                          );
                        }
                      })
                      .catch((fallbackError) => {
                        console.error('🛒 [ProductForm] ❌ Fallback also failed:', fallbackError);
                      });
                  });
              } else {
                console.log('🛒 [ProductForm] ⚠️ No sections to fetch, trying cart.js fallback');
                // Fallback: fetch cart.js to at least update count
                fetch(`${FoxThemeSettings.routes.cart_url}.js`)
                  .then((res) => res.json())
                  .then((cartData) => {
                    console.log('🛒 [ProductForm] Fallback cart data:', cartData);
                    if (cartData.item_count > 0) {
                      if (this.cartDrawer) {
                        this.cartDrawer.updateCartCountElements(cartData.item_count);
                      }
                      if (window.FoxThemeCartHelpers) {
                        window.FoxThemeCartHelpers.updateCartCount(cartData.item_count);
                      }
                      // Trigger cart refresh
                      document.dispatchEvent(
                        new CustomEvent("cart:refresh", {
                          detail: { open: FoxThemeSettings.cart.openDrawerWhenAdded !== false },
                        })
                      );
                    }
                  });
              }
              
              return;
            }

            if (
              !FoxThemeSettings.cart.openDrawerWhenAdded ||
              FoxThemeSettings.cart.cartType === "page"
            ) {
              this.Notification.show({
                target: this.errorWrapper ? this.errorWrapper : document.body,
                method: "appendChild",
                type: "success",
                message: FoxThemeStrings.item_added,
                last: 3000,
                sticky: this.notificationType === "toast",
              });
            }
            if (FoxThemeSettings.cart.cartType === "page") {
              FoxThemeCartHelpers.getState().then((state) => {
                FoxThemeCartHelpers.updateCartCount(state.item_count);
              });
            }

            this.error = false;
            window.FoxThemeEvents.emit(PUB_SUB_EVENTS.cartUpdate, response);

            // DispatchEvent for third-party
            document.dispatchEvent(
              new CustomEvent("product-ajax:added", {
                detail: {
                  product: response,
                },
              })
            );
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("btn--loading");
            this.submitButton.removeAttribute("aria-disabled");
          });
      }
    }
  );
}
